import type {AfriexRichTextDocument} from '@afriex/core/domain/types';
import {isRichTextDocumentEmpty} from '@afriex/core/utils';

import RichTextEditor from '@/components/RichTextEditor';
import type {BusinessProductUpdateCategory} from '@/types';

import {CATEGORY_STYLES} from '../categoryStyles';

type Props = {
  title: string;
  content?: AfriexRichTextDocument;
  category: BusinessProductUpdateCategory;
  authorName: string;
  authorRoleLabel: string;
};

// Mirrors the Business Portal notification panel's styling; no shared component layer to import it from.
const PreviewCard = ({
  title,
  content,
  category,
  authorName,
  authorRoleLabel,
}: Props) => {
  const categoryStyle = CATEGORY_STYLES[category];

  return (
    <div className="w-full max-w-sm rounded-lg bg-white p-4 text-neutral-900 shadow-lg">
      <div className="mb-2 flex items-center gap-1 text-sm text-neutral-500">
        <span>‹</span>
        <span>Notifications</span>
      </div>
      {categoryStyle && (
        <span
          className={`mb-2 inline-block w-fit rounded-full px-2 py-0.5 text-xs font-medium ${categoryStyle.className}`}
        >
          {categoryStyle.label}
        </span>
      )}
      <h3 className="text-base font-bold leading-snug">
        {title || 'Untitled update'}
      </h3>
      <p className="mb-3 mt-1 text-xs text-neutral-500">
        Just now{authorRoleLabel ? ` · ${authorRoleLabel}` : ''}
        {authorName ? ` (${authorName})` : ''}
      </p>
      {isRichTextDocumentEmpty(content) ? (
        <p className="text-sm text-neutral-400">Message body…</p>
      ) : (
        <RichTextEditor
          value={content}
          editable={false}
          variant="plain"
          className="text-neutral-800"
        />
      )}
    </div>
  );
};

export default PreviewCard;
